import { CSSProperties } from 'react';
import { MBHover } from '@shared/components/hover';
import { MBListRow, MBListRowProps } from '@shared/components/list';
import { useBoolean } from '@shared/util/hooks';

interface MBMenuRowProps extends MBListRowProps {
  isActive?: boolean;
  wrapperStyle?: CSSProperties;
}

export function MBMenuRow({ isActive, wrapperStyle, ...props }: MBMenuRowProps) {
  const [isHovered, onHoverStart, onHoverEnd] = useBoolean(false);

  const activeBackgroundColor = 'var(--theme-background-gray)';
  const hoverBackgroundColor = 'var(--color-v2-gray05)';

  let backgroundColor: string | undefined;
  if (isActive) {
    backgroundColor = activeBackgroundColor;
  } else if (isHovered) {
    backgroundColor = hoverBackgroundColor;
  }

  const containerStyle: CSSProperties = {
    ...wrapperStyle,
    overflow: 'hidden',
    backgroundColor,
  };

  return (
    <MBHover
      hoverContainerStyle={containerStyle}
      onHoverStart={onHoverStart}
      onHoverEnd={onHoverEnd}
    >
      <MBListRow {...props} />
    </MBHover>
  );
}
